exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".side-menu-item-contents {\n  height: 45px; }\n  .side-menu-item-contents .metric-name {\n    line-height: 2.5;\n    font-weight: 600;\n    margin-top: -5;\n    display: block; }\n    .side-menu-item-contents .metric-name i {\n      color: #5d6368; }\n  .side-menu-item-contents .metric-count {\n    line-height: 0.3;\n    font-size: 14px;\n    color: #979b9f !important;\n    display: block;\n    height: 0px; }\n\n.ant-menu-item:hover {\n  color: #00c6d7; }\n  .ant-menu-item:hover .metric-name i {\n    color: #5d6368; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Analytics/components/common/SideMenuItemContents/style.scss
// module id = 986
// module chunks = 0